// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_id-0";
export var fileCarousel = "_id-2";
export var removeFileButton = "_id-1";